import { Box, Button, Dialog, DialogTitle, Paper, Stack, Typography } from "@mui/material";

interface Props {
  open: boolean;
  message?: string;
  isSubmitting?: boolean;
  handleCancel: () => void;
  handleConfirm: () => void;
}

const ConnectabilityConfirmModal = ({
  open,
  message,
  isSubmitting,
  handleCancel,
  handleConfirm,
}: Props) => {
  return (
    <Dialog open={open} PaperProps={{ sx: { width: "480px", maxWidth: "480px" } }}>
      <Paper sx={{ padding: "16px 24px 20px 24px" }}>
        <DialogTitle sx={{ padding: "0px 0px 4px 0px" }}>This change affects connected brands</DialogTitle>

        <Box
          sx={{
            mt: 1,
            border: "1px solid #ED6C0280",
            borderRadius: "5px",
            backgroundColor: "#fff8f0",
            p: 1.5,
          }}
        >
          <Typography sx={{ fontSize: 14, color: "#000000DE" }}>
            {message ||
              "Removing this item may impact brands currently connected to this family. Continue anyway?"}
          </Typography>
        </Box>

        <Stack flexDirection="row" justifyContent="space-between" marginTop={2}>
          <Button variant="outlined" color="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="warning"
            onClick={handleConfirm}
            disabled={isSubmitting}
          >
            Continue anyway
          </Button>
        </Stack>
      </Paper>
    </Dialog>
  );
};

export default ConnectabilityConfirmModal;
